// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__4ZRZU","productName":"Table_productName__3NrAg"};